import {
  isFrameGroupRoute,
  isPageSectionRoute,
  isPreviewFrameCanvasRoute,
  isPreviewSectionCanvasRoute,
} from '@sketch/modules-common'

import { CanvasFocus, PAGE_FOCUS } from './types'

interface FocusRouteParams {
  frameUUID?: string
  sectionUUID?: string
}

/**
 * Which entity - if any - the current route focuses the canvas on.
 *
 * Share and Preview have separate route templates for the same three views, so
 * both are matched here: the distinction between the two hosts belongs to the
 * host, not to what the canvas is showing.
 *
 * A focus route whose UUID param is missing falls back to the page rather than
 * producing a focus with no entity, which nothing downstream could act on.
 */
export function deriveCanvasFocus(
  path: string,
  params: FocusRouteParams
): CanvasFocus {
  if (isFrameGroupRoute(path) || isPreviewFrameCanvasRoute(path)) {
    return params.frameUUID
      ? { kind: 'frame', uuid: params.frameUUID }
      : PAGE_FOCUS
  }

  if (isPageSectionRoute(path) || isPreviewSectionCanvasRoute(path)) {
    return params.sectionUUID
      ? { kind: 'section', uuid: params.sectionUUID }
      : PAGE_FOCUS
  }

  return PAGE_FOCUS
}
